import React, { Fragment, useContext, useEffect, useState } from "react";
import { SessionContext } from "../../../utility/useSession";
import propTypes from "prop-types";
import LocationPickerDialog from "../../../components/pickers/locationPicker/LocationPickerDialog";
import { AssetLocation, AssetLocationTypes, KeyManagementTypes } from "../../../logic/api";
import KeyAuditScanner from "./KeyAuditScanner";
import { useTranslation } from "react-i18next";
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";

const KeyAuditLocation: React.FunctionComponent<{
    show: boolean;
    enforceKeyPositionAudit?: boolean;
    onClose: () => void;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (session.current.site == null) {
        return <Fragment></Fragment>;
    }

    const [showLocationPicker, setShowLocationPicker] = useState(false);
    const [showAuditScanner, setShowAuditScanner] = useState(false);
    const [location, setLocation] = useState<AssetLocation | null>();
    const releaseReturnToLocationsListOnSubmit = useReleaseManagement(ReleaseFlag.returnToLocationsListOnSubmit);

    useEffect(() => {
        if (props.show == true) {
            setShowLocationPicker(true);
        }
    }, [props.show]);

    const keySelectionTypes = [AssetLocationTypes.Lane, AssetLocationTypes.Zone, AssetLocationTypes.User, AssetLocationTypes.DynamicBox, AssetLocationTypes.Hook, AssetLocationTypes.KeyBox];

    return <Fragment>
        <LocationPickerDialog
            title={t("keys.labels.selectLocationAudit")}
            show={showLocationPicker}
            displayTypes={[AssetLocationTypes.Zone, AssetLocationTypes.Lane, AssetLocationTypes.Users, AssetLocationTypes.User, AssetLocationTypes.Keyroom, AssetLocationTypes.Hook, AssetLocationTypes.KeyBox, AssetLocationTypes.DynamicBox]}
            selectionTypes={keySelectionTypes}
            keyManagementTypes={[KeyManagementTypes.box, KeyManagementTypes.hook]}
            displayInactiveLocations={false}
            onChange={(loc) => {
                if (loc == null) {
                    setShowLocationPicker(false);
                    props.onClose();
                    return;
                }
                setShowLocationPicker(false);
                setLocation(loc);
                setShowAuditScanner(true);
            }}

        >
        </LocationPickerDialog>

        {location != null && (
            <KeyAuditScanner enforceKeyPositionAudit={props.enforceKeyPositionAudit} show={showAuditScanner} onClose={(submitted) => {
                if (releaseReturnToLocationsListOnSubmit && submitted == true) {
                    setLocation(null);
                    setShowAuditScanner(false);
                    setShowLocationPicker(true);
                } else {
                    setShowAuditScanner(false);
                    props.onClose();
                }

            }} location={location}></KeyAuditScanner>
        )}


    </Fragment>
}

KeyAuditLocation.propTypes = {
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired
}

export default KeyAuditLocation;
